if ('NodeList' in window && !NodeList.prototype.forEach) {
	console.info('polyfill for IE11');
	NodeList.prototype.forEach = function (callback, thisArg) {
		thisArg = thisArg || window;
		for (let i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this);
		}
	};
}

// LENIS
const lenis = new Lenis({
	duration: 1.2,
	smooth: true,
	smoothTouch: false,
});

(function () {
	addBtnSvgs();

	// MOBILE SUB-MENU TO SELECT
	document.querySelectorAll('.js-is_mobile #content .sub-menu').forEach((submenu) => {
		const submenuWrapper = document.createElement('div');
		submenuWrapper.classList.add('sub-menu_container');
		submenuWrapper.setAttribute('data-fromjs', '');
		submenuWrapper.setAttribute('data-scrollFromUrl', 'subNav');
		submenu.parentNode.insertBefore(submenuWrapper, submenu);
		submenuWrapper.appendChild(submenu);

		const activeItem = submenu.querySelector('a.active') ? submenu.querySelector('a.active') : submenu.querySelector('a');
		const items = Array.from(submenu.querySelectorAll('a'))
			.map(
				(link) => `
				<li data-value="${link.textContent.trim()}" class="${link.classList}">
					<a href="${link.getAttribute('href')}">${link.textContent.trim()}</a>
				</li>
			`
			)
			.join('');

		submenu.querySelector('ul').classList.add('hidden');

		submenu.insertAdjacentHTML(
			'beforeend',
			`<div class="customSelect" data-value="" data-custom_select>
				<input type="hidden" value="${activeItem.getAttribute('href')}" name="sub-menu">
				<input value="${parent_seoname ? parent_seoname : activeItem.textContent.trim()}" type="text" readonly>

				<ul>${items}</ul>
			</div>`
		);

		submenu.querySelector('.customSelect').dataset.value = activeItem.getAttribute('href');
	});

	// WRAP TEXT CHARS INTO SPANs
	// splitCharsWrap('[data-split_chars], .privary-navigation__submenu a');

	// TABS TEXT
	document.querySelectorAll('.js-tabs').forEach((mod) => {
		mod.querySelectorAll('.js-tabs_link').forEach((link) => {
			link.addEventListener('click', (e) => {
				const item = mod.querySelector(`[data-id="${link.getAttribute('href').replace('#', '')}"]`);
				if (item) {
					e.preventDefault();
					mod.querySelectorAll('.js-tabs_item, .js-tabs_link').forEach((el) => el.classList.remove('active'));
					item.classList.add('active');
					link.classList.add('active');
					updateBtnSvgs();
				}
			});
		});
	});

	// ADD MOBILE NAV LOGO
	if (document.querySelector('.navigation .inner')) {
		document
			.querySelector('.navigation .inner')
			.insertAdjacentHTML('afterbegin', `<a href="/" class="navigation-logo" data-fromjs><img src="/assets/images/logo-nav2.png" alt="Charlestowne "></a>`);
	}

	// MOBILE SUBNAV TOGGLE
	document.querySelectorAll('.navigation .noclick').forEach((btn) => {
		btn.addEventListener('click', (e) => {
			e.preventDefault();
			e.stopPropagation();
			document.querySelectorAll('.navigation .sub-sub-menu, .navigation .noclick').forEach((item) => {
				if (item !== btn && item !== btn.nextElementSibling) {
					item.classList.remove('active');
				}
			});
			btn.classList.toggle('active');
			btn.nextElementSibling.classList.toggle('active');
		});
	});
	document.querySelectorAll('.navigation').forEach((nav) => {
		nav.addEventListener('click', (e) => {
			if (!e.target.hasAttribute('href')) {
				document.querySelectorAll('.navigation .sub-sub-menu, .navigation .noclick').forEach((item) => item.classList.remove('active'));
			}
		});
	});

	// OPEN MAIN NAV MOBILE
	document.querySelectorAll('[data-toggle_nav_m], .close-menu').forEach((btn) => {
		if (document.querySelector('.navigation')) {
			btn.addEventListener('click', (e) => {
				document.querySelector('.navigation').classList.toggle('active');
				document.body.classList.toggle('no-scroll', document.querySelector('.navigation').classList.contains('active'));
			});
		}
	});

	// TEAM FILTER
	document.querySelectorAll('.js-team').forEach((module) => {
		// GET ACTIVE FILTERS FORM SELECTS - RETURNS AN ARRAY OF STRINGS
		const getFilters = () => [...module.querySelectorAll('.js-teamFilter')].map((select) => select.dataset.value);

		// TEST WETHER AN ITEM MATCH ALL ACTIVE FILTERS - RETURNS A BOOLEAN
		const itemMatch = (filters = [], itemTags = '') => filters.every((filter) => itemTags.indexOf(filter) > -1);

		module.querySelectorAll('.js-teamFilter').forEach((select) => {
			select.addEventListener('change', () => {
				module.querySelectorAll('.js-teamItem').forEach((item) => {
					item.classList.toggle('hidden', !itemMatch(getFilters(), item.dataset.tags));
					if (lenis) {
						lenis.scrollTo('top', { duration: 0.6, lock: true });
					}
					// console.log(itemMatch(getFilters(), item.dataset.tags), getFilters(), item.dataset.tags);
				});
			});
		});
	});

	// TOGGLE MAIN NAV TABLET
	document.querySelectorAll('[data-toggle_nav]').forEach((btn) => {
		if (document.querySelector('.privary-navigation')) {
			btn.addEventListener('click', (e) => {
				btn.classList.toggle('active');
				btn.querySelector('span').textContent = btn.classList.contains('active') ? 'Close' : 'Menu';
				document.querySelector('.privary-navigation').classList.toggle('active');
			});
		}
	});

	// REMOVE BOTTOM MARGIN FROM INTRO CONTENT
	document.querySelectorAll('.js-introBmZero').forEach((mod) => {
		const previousMod = mod.previousElementSibling;
		if (previousMod.classList.contains('introContent')) {
			previousMod.classList.add('mb-0');
			// mod.classList.add('mt-0');
		}
	});

	// FORM BY STEPS
	document.querySelectorAll('.js-form-steps').forEach((form) => {
		form.querySelectorAll('.form-module__group').forEach((group, i) => {
			group.setAttribute('data-step', i);

			if (i + 1 === form.querySelectorAll('.form-module__group').length) {
				group.setAttribute('data-step-last', '');
			}

			if (i === 0) {
				group.setAttribute('data-step-first', '');
				group.classList.add('active');
			}

			// CREATE PREV-NEXT BUTTONS PER GROUP
			group.insertAdjacentHTML(
				'beforeend',
				`<div class="form-module__group-foot" data-fromjs>
					<button class="btn" type="button" data-prev data-formnav="${i - 1}">Prev</button>
					<button class="btn" type="button" data-next data-formnav="${i + 1}">Next</button>
				</div>`
			);
		});

		// HIDE GDPR AND SUBMIT ON INIT
		const lastStep = form.querySelector('[data-step-last]');
		const formExtraItems = form.querySelectorAll(`.gdpr-wrap, .form-module__submit`);

		if (lastStep && !lastStep.classList.contains('active')) {
			formExtraItems.forEach((item) => item.classList.add('hidden'));
		}

		form.querySelectorAll('[data-formnav]').forEach((btn) => {
			btn.addEventListener('click', () => {
				const btnTarget = form.querySelector(`[data-step="${btn.dataset.formnav}"]`);
				form.querySelectorAll('[data-step]').forEach((group) => group.classList.remove('active'));

				if (btnTarget) {
					btnTarget.classList.add('active');
				}

				// TOGGLE GDPR AND SUBMIT ON CLICK
				formExtraItems.forEach((item) => {
					item.classList.toggle('hidden', lastStep && !lastStep.classList.contains('active'));
				});
			});
		});
	});

	// ANIMATE FORM LABELS ON FOCUS
	const fieldSelectors = '.form-module__field input, .form-module__field select, .form-module__field textarea';
	document.querySelectorAll('.form-module').forEach((form) => {
		form.querySelectorAll(fieldSelectors).forEach((field) => {
			field.addEventListener('focus', () => field.parentElement.classList.add('move'));
			// field.addEventListener('blur', () => field.parentElement.classList.remove('move'));
		});
	});

	// CONTACT STEPS NAV
	document.querySelectorAll('.js-contactMod').forEach((mod) => {
		mod.querySelectorAll('.js-contactMod-goTo').forEach((btn, i) => {
			btn.addEventListener('click', (e) => {
				const btnHref = btn.getAttribute('href');
				if (btnHref.indexOf('#') === 0) {
					e.preventDefault();
					mod.querySelectorAll('.js-contactMod-item, .js-contactMod-goTo').forEach((item) => item.classList.remove('active'));
					mod.querySelector(btnHref).classList.add('active');
					btn.classList.add('active');
				}
			});

			if (i === 0) btn.click();
		});
	});

	// RESET FORMS ON PAGE-LOAD (AVOID PRE-FILLED FORMS)
	document.querySelectorAll('.form-module').forEach((form) => {
		form.setAttribute('autocomplete', 'off');
	});

	// CASE STUDY SEARCH
	document.querySelectorAll('.js-caseStu').forEach((module) => {
		module.querySelectorAll('.js-caseStuForm').forEach((form) => {
			form.addEventListener('submit', (e) => {
				e.preventDefault();

				// GET SEARCH VALUE - RETURNS A STRING
				const query = form.elements['q'].value;

				// TEST WETHER AN ITEM MATCH SEARCH - RETURNS A BOOLEAN
				const itemMatch = (q = '', itemQuery = '') => itemQuery.toLowerCase().indexOf(q.toLowerCase()) > -1;

				module.querySelectorAll('.js-caseStuItem').forEach((item) => {
					item.classList.toggle('hidden', !itemMatch(query, item.dataset.query));
				});
			});
		});
	});

	// PORTFOLIO FILTER
	document.querySelectorAll('.js-portfolio').forEach((module) => {
		const form = module.querySelector('.js-portfolioForm');
		const noResults = module.querySelector('.js-portfolioNoResults');

		// GET ACTIVE FILTERS FORM SELECTS - RETURNS AN ARRAY OF STRINGS
		const getFilters = () => [...module.querySelectorAll('.js-portfolioFilter')].map((select) => select.dataset.value);

		// TEST WETHER AN ITEM MATCH ALL ACTIVE FILTERS - RETURNS A BOOLEAN
		const itemMatch = (filters = [], itemTags = '') => filters.every((filter) => itemTags.indexOf(filter) > -1);

		module.querySelectorAll('.js-portfolioFilter').forEach((select) => {
			select.addEventListener('change', () => {
				// console.log(getFilters());
				module.querySelectorAll('.js-portfolioItem').forEach((item) => {
					item.classList.toggle('hidden', !itemMatch(getFilters(), item.dataset.tags));
				});

				// IF ITEMS NO MATCH FILTERS
				if (noResults) {
					noResults.classList.toggle('hidden', module.querySelectorAll('.js-portfolioItem:not(.hidden)').length > 0);
				}

				if (form) {
					const formQtring = new URLSearchParams(new FormData(form)).toString();
					window.history.pushState(null, '', `?${formQtring}`);
				}
				if (lenis) {
					setTimeout(() => {
						lenis.scrollTo(module, { duration: 0.6, offset: -100, lock: true });
					}, 500);
				}
			});
		});

		// RESET FORM
		if (form) {
			form.addEventListener('reset', () => {
				module.querySelectorAll('.js-portfolioItem').forEach((item) => item.classList.remove('hidden'));
				module.querySelectorAll('.js-portfolioFilter').forEach((select) => select.querySelector('li').click());
				window.history.pushState(null, '', '?r');
			});
		}

		// GET URL PARAMETERS
		const urlSearch = window.location.search.slice(1);
		const urlParams = urlSearch.split('&');

		document.addEventListener('DOMContentLoaded', () => {
			urlParams.forEach((param) => {
				const paramArray = param.split('=');
				const DOMoption = module.querySelector(`[data-tag="${decodeURI(paramArray[1])}"]`);

				if (DOMoption) {
					DOMoption.click();
				}
			});
		});
	});

	// PORTFOLIO CUSTOM VALIDATION - DISABLE REST OF SELECTS
	document.querySelectorAll('.js-portfolioForm').forEach((form) => {
		form.querySelectorAll('.gridPortfolioMod_select-1 li').forEach((opt) => {
			opt.addEventListener('click', () => {
				form.querySelectorAll('.js-portfolioFilter:not(.gridPortfolioMod_select-1)').forEach((sel) => {
					sel.classList.toggle('disabled', opt.dataset.tag === 'Food_Beverage_Outlets');
				});
			});
		});
	});

	// VALIDATE PRIMARY SUBNAVs
	document.querySelectorAll('.privary-navigation__item').forEach((item) => {
		if (item.querySelectorAll('.submenu').length > 0) {
			item.classList.add('has-submenu');
		}
	});

	// Remove empty <p> tags created by tinymce
	const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach((e) => e.innerHTML.trim() === '' && e.parentNode.removeChild(e));

	// FANCYBOX SETTINGS
	// $.fancybox.defaults.autoFocus = false;
	// $.fancybox.defaults.backFocus = false;
	$.fancybox.defaults.touch = false;
	$.fancybox.defaults.smallBtn = true;
	$.fancybox.defaults.loop = true;
	$.fancybox.defaults.btnTpl.smallBtn = `<button class="fancybox-button fancybox-close-small" title="{{CLOSE}}" type="button" data-fancybox-close><svg width="100" height="100" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><rect width="100" height="100" fill="#FFFFFF" /><path stroke="#6b0b2f" stroke-width="2px" d="M 25 25 L 75 75 M 75 25 L 25 75" /></svg></button>`;
	$.fancybox.defaults.btnTpl.arrowLeft = `<button class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}" type="button" data-fancybox-prev><span>Prev</span><svg width="25" height="16" viewBox="0 0 25 16" fill="none" stroke="currentColor" stroke-width="1" xmlns="http://www.w3.org/2000/svg"><path d="M 25 8 H 1 M 9 0 L 0 8 L 9 16" /></svg></button>`;
	$.fancybox.defaults.btnTpl.arrowRight = `<button class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}" type="button" data-fancybox-next><span>Next</span><svg width="25" height="16" viewBox="0 0 25 16" fill="none" stroke="currentColor" stroke-width="1" xmlns="http://www.w3.org/2000/svg"><path d="M 0 8 H 24 M 16 0 L 25 8 L 16 16" /></svg></button>`;

	const swiperADAduplicatedProcess = (currentSwiper) => {
		currentSwiper.slides.forEach((slide) => {
			if (slide.classList.contains('swiper-slide-duplicate')) {
				slide.setAttribute('aria-hidden', true);
				slide.setAttribute('tabindex', '-1');

				// REMOVE IDs
				slide.querySelectorAll('[id]').forEach((elementWithID) => {
					elementWithID.setAttribute('id', '');
				});

				// SET TABINDEXs -1
				slide.querySelectorAll('a').forEach((elementWithID) => {
					elementWithID.setAttribute('tabindex', '-1');
				});
			}
		});

		currentSwiper.el.querySelectorAll('.swiper-slide .swiper-pagination-bullet').forEach((dotInSlide) => {
			dotInSlide.setAttribute('tabindex', '-1');
		});
	};

	// SWIPER
	const swiperClass = '.sym-slides';
	const swiperOps = {
		loop: true,
		fadeEffect: { crossFade: true },
		allowTouchMove: true,
		breakpoints: {
			767: {
				allowTouchMove: false,
			},
		},
		on: {
			init: function (currentSwiper) {
				swiperADAduplicatedProcess(currentSwiper);
				fancyboxRemoveSwiperClones();
			},
		},
	};

	document.querySelectorAll(swiperClass).forEach((slider, i) => {
		const dataOps = slider.dataset.swiper ? JSON.parse(slider.dataset.swiper) : {};
		const combinedOps = Object.assign({}, swiperOps, dataOps);

		slider.setAttribute(`data-swiper${i}`, '');
		const swiper = new Swiper(`[data-swiper${i}]`, combinedOps);

		swiper.on('slideChange', (currentSwiper) => {
			swiperADAduplicatedProcess(currentSwiper);
		});
	});

	document.querySelectorAll('[data-swiper-goto]').forEach((item) => {
		const target = item.dataset.swiperGoto ? parseInt(item.dataset.swiperGoto) : 0;
		const slider = item.dataset.swiperTarget ? document.querySelector(item.dataset.swiperTarget) : item.closest('.sym-slides');

		item.addEventListener('click', () => {
			slider.swiper.slideTo(target);
			item.parentNode.querySelectorAll('[data-swiper-goto]').forEach((itm) => itm.classList.remove('js-swiper_active'));
			item.classList.add('js-swiper_active');
		});
	});

	// LENIS
	function raf(time) {
		lenis.raf(time);
		requestAnimationFrame(raf);
	}

	requestAnimationFrame(raf);

	// FANCYBOX - PREVENT LENIS
	$.fancybox.defaults.beforeShow = function (e) {
		[...e.current.$slide].forEach((slide) => slide.setAttribute('data-lenis-prevent', ''));
	};

	// REMOVE SWIPER CLONES FROM FANCYBOX
	function fancyboxRemoveSwiperClones() {
		document.querySelectorAll('.swiper-slide-duplicate [data-fancybox]').forEach((link) => {
			link.removeAttribute('data-fancybox');
		});
	}

	// BACK TO TOP MODULE
	document.querySelectorAll('[data-backtotop]').forEach((item) => {
		item.addEventListener('click', () => {
			lenis.scrollTo(0, { duration: 2 });
		});
	});

	// CUSTOM SELECT
	document.querySelectorAll('[data-custom_select]').forEach((select) => {
		const selectField = select.querySelector('[type="hidden"]');
		const selectLabel = select.querySelector('[type="text"]');

		if (selectLabel) {
			selectLabel.addEventListener('click', () => select.classList.toggle('active'));
		}

		select.querySelectorAll('li').forEach((li) => {
			li.addEventListener('click', () => {
				if (selectField) {
					selectField.setAttribute('value', li.dataset.tag);
				}

				if (selectLabel) {
					selectLabel.setAttribute('value', li.dataset.value);
				}

				select.querySelectorAll('li').forEach((l) => l.classList.remove('active'));
				li.classList.add('active');

				select.classList.remove('active');

				select.setAttribute('data-value', li.dataset.tag);
				select.dispatchEvent(new Event('change'));
			});
		});
	});

	

})();

function splitCharsWrap(selectors) {
	document.querySelectorAll(selectors).forEach((txt) => {
		txt.innerHTML = wrapWords(txt.innerHTML);
		txt.querySelectorAll('[data-word]').forEach((wordSpan) => {
			const wrappedChars = wordSpan.textContent.replace(/\S/g, `<span class="char" data-char data-fromjs>$&</span>`);
			wordSpan.innerHTML = wrappedChars;
		});
	});
}

function addBtnSvgs() {
	document.querySelectorAll('.btn, .signup-btn, .sub-menu a').forEach((btn) => {
		if (btn.querySelectorAll('svg').length < 1) {
			// const outerFrame = `<svg class="outerFrame" width="367" height="50" viewBox="0 0 367 50" preserveAspectRatio="none" vector-effect="non-scaling-stroke" shape-rendering="crispEdges"><mask id="myMask"><rect x="1" y="1" width="365" height="48" fill="none" stroke="white" stroke-width="0.9" vector-effect="non-scaling-stroke" shape-rendering="crispEdges" /></mask><g mask="url(#myMask)"><circle cx="50" cy="50" r="365" fill="url('#btn-gradient1')" /></g></svg>`;
			const btnWidth = btn.offsetWidth - 8 || 112;
			const btnHeight = btn.offsetHeight - 8 || 50;
			const innerFrame = `
				<svg class="innerFrame" width="${btnWidth}" height="${btnHeight}" viewBox="-0.5 -0.5 ${btnWidth + 1} ${btnHeight + 1}" fill="none" stroke="currentColor" stroke-width="1" preserveAspectRatio="none">
					<path d="M 0 0 H ${btnWidth} V ${btnHeight} H 0 V -0.5" pathLength="1" vector-effect="non-scaling-stroke" shape-rendering="crispEdges" />
				</svg>
			`;
			btn.insertAdjacentHTML('afterbegin', `${innerFrame}`);
		}
	});
}

function updateBtnSvgs() {
	document.querySelectorAll('.btn, .signup-btn, .sub-menu a').forEach((btn) => {
		const btnFrame = btn.querySelector('.innerFrame');
		if (btnFrame && btn.offsetWidth - 8 !== btnFrame.getBBox().width) {
			btnFrame.remove();
			if (window.innerWidth > 991) {
				setTimeout(() => addBtnSvgs(), 100);
			}
		}
	});
}

// WRAP WORDS TO ANIMATE
function wrapWords(html) {
	const div = document.createElement('div');
	div.innerHTML = html;
	lookForChildren(div);
	return div.innerHTML.replace(/spfrnt/g, ' <span class="word" data-word data-fromjs>').replace(/spback/g, '</span> ');
}
function lookForChildren(node) {
	if (node.childNodes) {
		loopChildren(node.childNodes);
	}
}
function loopChildren(nodes) {
	for (const node of nodes) {
		addSpanTplToNode(node);
		if (node.childNodes) {
			lookForChildren(node);
		}
	}
}
function addSpanTplToNode(node) {
	if (node.nodeType !== 3) return;

	const words = node.data.split(' ');
	const str = words.reduce((tpl, word) => `${tpl} ${word.length > 0 ? `spfrnt${word}spback` : word}`, '');
	node.data = str.trim();
}
